var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Container, Grid, Heading, Separator } from 'telia-front-react';
import { observer } from 'mobx-react';
import React, { Component } from 'react';
import DiilCustomerRequiredNotice from '../auth/DiilCustomerRequiredNotice';
import RepresentationRights from '../person/representation-rights/RepresentationRights';
import PersonWrapper from '../person/PersonWrapper';
import { injectStores } from '../util/StoresUtil';
import LoggingApi from '../api/LoggingApi';
let AccountPage = class AccountPage extends Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "translateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "ssoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    componentDidMount() {
        LoggingApi.postLog(location.pathname);
    }
    getBody() {
        const { translate } = this.translateStore;
        if (!this.ssoStore.isPrivateCustomer) {
            return React.createElement(DiilCustomerRequiredNotice, null);
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(Heading, { element: "h1", className: "h1" }, translate('accountPage.title')),
            React.createElement(Separator, { color: "invisible", spacing: "xsmall" }),
            React.createElement(Grid, { borderWeight: "thin" },
                React.createElement(PersonWrapper, null),
                React.createElement(RepresentationRights, null))));
    }
    render() {
        return React.createElement(Container, null, this.getBody());
    }
};
AccountPage = __decorate([
    injectStores,
    observer
], AccountPage);
export default AccountPage;
